@if (visible) {
  <ng-container
    *ngTemplateOutlet="mobile ? mobileLayout : desktopLayout"
  ></ng-container>
}

<ng-template #desktopLayout>
  <div id="filter-container" class="filter--container filter-scroll">
    <div [ngStyle]="styles">
      <div class="d-flex justify-content-between align-items-center">
        <h5 class="fw-bold uppercase">Filter By:</h5>
        @if (hasSelectedFilters) {
          <a
            id="btn-clear-all-filters"
            class="link link-underline small"
            (click)="clearAll()"
            >Clear All</a
          >
        }
      </div>
      <ul class="products-list__filters mb-0">
        @for (filter of sortedFiltersGroup; track filter) {
          @if (isVisible(filter)) {
            <li class="products-list__filters__section">
              <filter-group
                [filter]="filter"
                [filterItemHeight]="filterItemMaxHeight"
                (toggledFilter)="onToggleDropdown($event)"
                (changedFilter)="onFilterChanged($event)"
                (updatedFilter)="onUpdateFilters($event)"
              ></filter-group>
            </li>
          }
        }
      </ul>
    </div>
  </div>
</ng-template>

<ng-template #mobileLayout>
  <div class="position-relative">
    <a
      id="btn-filter-by-mobile"
      href="#"
      class="link link-underline uppercase"
      (click)="toggleFiltersModal()"
      >Filter By&nbsp;<i class="fas fa-filter"></i
    ></a>
    <div
      class="filter-content__mobile p-2"
      [ngStyle]="mobileDialogStyles"
      [ngClass]="{ opened: mobileOpened }"
    >
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-baseline">
          <h5 class="fw-bold uppercase">Filter By</h5>
          @if (hasSelectedFilters) {
            <a
              id="btn-clear-all-filters-mobile"
              class="ms-3 link link-underline small"
              (click)="clearAll()"
              >Clear All</a
            >
          }
        </div>
        <button
          id="btn-close-filter-mobile"
          type="button"
          (click)="toggleFiltersModal()"
          class="btn btn-icon close"
          aria-label="Close"
        >
          <span class="far fa-times fw-bold" aria-hidden="true"></span>
        </button>
      </div>
      <ul class="products-list__filters mb-0">
        @for (filter of _filters; track filter) {
          @if (isVisible(filter)) {
            <li class="products-list__filters__section">
              <filter-group
                [filter]="filter"
                [filterItemHeight]="filterItemMaxHeight"
                (changedFilter)="onFilterChanged($event)"
                (toggledFilter)="onToggleDropdown($event)"
                (updatedFilter)="onUpdateFilters($event)"
              ></filter-group>
            </li>
          }
        }
      </ul>
    </div>
  </div>
</ng-template>
